export const CoinsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className="stroke-icon"
      {...props}
    >
      <path
        // eslint-disable-next-line max-len
        d="M10.601 4C11.8636 2.76281 13.5927 2 15.5 2C19.366 2 22.5 5.13401 22.5 9C22.5 10.9073 21.7372 12.6365 20.4999 13.899M16.5 15C16.5 18.866 13.366 22 9.5 22C5.63401 22 2.5 18.866 2.5 15C2.5 11.134 5.63401 8 9.5 8C13.366 8 16.5 11.134 16.5 15Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
